import { loadData, saveData } from '@/utils/localStorage'
import {
  LOCAL_STORAGE_LAYOUT_CONFIG_KEY,
  LAYOUT_CONFIG
} from '@/constants/layout'

export function getDefaultLayoutConfig() {
  return JSON.parse(JSON.stringify(LAYOUT_CONFIG))
}

export function loadLayout() {
  const DEFAULT_LAYOUT_CONFIG = getDefaultLayoutConfig()
  const layoutConfig =
    loadData(LOCAL_STORAGE_LAYOUT_CONFIG_KEY) || getDefaultLayoutConfig()

  return layoutConfig.version === DEFAULT_LAYOUT_CONFIG.version
    ? layoutConfig.layouts
    : DEFAULT_LAYOUT_CONFIG.layouts
}

export function saveLayout(layouts) {
  return saveData(LOCAL_STORAGE_LAYOUT_CONFIG_KEY, {
    version: LAYOUT_CONFIG.version,
    layouts
  })
}
